import { useQuery } from '@tanstack/react-query';
import { unitPricingApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const REFERENCE_STALE_TIME = 10 * 60_000;

/** @registry Unit pricing reference rows used by the change template editor. */
export function useUnitPricing() {
  return useQuery({
    queryKey: queryKeys.unitPricing.list(),
    queryFn: ({ signal }) =>
      unitPricingApiClient.getUnitPricing(toCancelToken(signal)),
    staleTime: REFERENCE_STALE_TIME,
    meta: { errorContext: 'unit pricing' },
  });
}
